interface ITroublePopupParams {
  id?: string;
  popup?: HTMLElement;
  reason: string;
}

/**
 * @description
 * Конструктор для попапа с капчей/ошибкой.
 * @param {object} params Параметры для попапа.
 * @class
 * @alias TroublePopup
 * Singletone
 */
export class TroublePopup {
  constructor(params: ITroublePopupParams) {
    if (!TroublePopup.instance) {
      TroublePopup.instance = this;
    }

    this.id = "trouble-popup";
    this.popup = document.getElementById(this.id) as HTMLElement; // Принудительно говорим что этот параметр точно будет
    this.reason = params.reason;
    this.iframe = null;

    // Ловим событие, которое отправит в родительское окно попап капчи в айфрейме
    window.addEventListener("message", this.hide.bind(this), false);

    return TroublePopup.instance;
  }

  private static instance: TroublePopup;

  public id: string;

  public popup: HTMLElement;

  public reason: string;

  public iframe: HTMLIFrameElement | null;

  /**
   * Инициализация и отрисовка попапа.
   */
  public init(): void {
    this.renderPopup();
    this.insertPopupBody();
    this.show();
  }

  public renderPopup(): void {
    if (!this.popup) {
      this.popup = document.createElement("div");
      this.popup.setAttribute("id", this.id);
      this.popup.classList.add(this.id);
      document.body.appendChild(this.popup);
      this.loadPopupCss();
    }
  }

  /**
   * Показать попап.
   */
  public show(): void {
    this.popup?.classList.add(this.id + "_open");
  }

  /**
   * Скрыть попап.
   */
  public hide(eventMessage: MessageEvent): void {
    if (eventMessage.data === "close-react-captcha-frame") {
      this.popup.classList.remove(this.id + "_open");
    }
  }

  /**
   * Вставка содержимого попапа
   */
  public insertPopupBody(): void {
    if (this.popup) {
      this.popup.innerHTML = "<a class='close'></a>";
      this.popup?.appendChild(this.createPopupIframe());
    }
  }

  /**
   * Создать iframe для попапа. Тут будет содержимое попапа.
   */
  public createPopupIframe(): HTMLIFrameElement {
    const iframe = document.createElement("iframe");
    // По этому ID код внутри капчи вызовет коллбек через postMessage
    iframe.setAttribute("name", "litres-" + this.reason + "-react");

    iframe.setAttribute("scrolling", "auto");
    iframe.setAttribute("marginheight", "0");
    iframe.setAttribute("marginwidth", "0");
    iframe.classList.add("trouble-popup__iframe");
    iframe.classList.add(this.reason + "-popup-iframe");

    switch (this.reason) {
      case "captcha":
        // Постучимся на текущую страницу для того, что бы гарантированно получить капчу.
        iframe.setAttribute(
          "src",
          window.location.origin.indexOf("litres.ru") === -1
            ? "https://www.litres.ru/?captcha"
            : `${window.location.href}&captcha`
        );
        break;
      case "error-500":
        iframe.setAttribute(
          "src",
          "https://www.litres.ru/static/error_pages/litres.ru-500.html"
        );
        break;
    }

    this.iframe = iframe;
    return iframe;
  }

  /**
   * Загрузить css для попапа.
   */
  public loadPopupCss(): void {
    const link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = "https://www.litres.ru/static/gu_ajax/trouble_popup.css?v1";
    document.getElementsByTagName("head")[0].appendChild(link);
  }
}
